<div class="publishing-summary">
  <div *ngIf="!publishComplete" class="summary-content">
    <p class="subtitle">{{ 'i18n.domain.product-template.publishing-wizard.review-before-publish' | translate }}</p>
    <div class="products-list">
      <div *ngFor="let request of publishRequests" class="product-item">
        <div class="product-header">
          <h4>{{ 'i18n.domain.product-template.publishing-wizard.product' | translate }} {{ publishRequests.indexOf(request) + 1 }}</h4>
          <p-tag [value]="getPublishStatus(request)" [severity]="getStatusClass(request)"></p-tag>
        </div>
        <div class="product-details">
          <p><strong>{{ 'i18n.domain.product-template.publishing-wizard.template-id' | translate }}:</strong> {{ request.templateId }}</p>
          <p><strong>{{ 'i18n.domain.product-template.publishing-wizard.action' | translate }}:</strong> {{ request.resolutionOption === 0 ? ('i18n.domain.product-template.publishing-wizard.create-new' | translate) : ('i18n.domain.product-template.publishing-wizard.update-existing' | translate) }}</p>
          <p *ngIf="request.resolutionOption !== 0"><strong>{{ 'i18n.domain.product-template.publishing-wizard.target-product-id' | translate }}:</strong> {{ request.existingProductIdToUpdate }}</p>
        </div>
      </div>
    </div>
    <div class="summary-footer">
      <p class="item-count">{{ publishRequests.length }} {{ 'i18n.domain.product-template.publishing-wizard.items-ready' | translate }}</p>
      <p-button label="{{ 'i18n.domain.product-template.publishing-wizard.confirm-publish' | translate }}" icon="pi pi-check" [loading]="isPublishing" (onClick)="onPublish()"></p-button>
    </div>
  </div>
  <div *ngIf="publishComplete" class="success-message">
    <div class="success-icon">✓</div>
    <h3>{{ 'i18n.domain.product-template.publishing-wizard.success-title' | translate }} {{ publishedProducts.length }} {{ 'i18n.domain.product-template.publishing-wizard.items-published' | translate }}</h3>
    <p class="success-details">{{ 'i18n.domain.product-template.publishing-wizard.success-message' | translate }}</p>
  </div>
</div>
